module.exports = "... coming soon ...\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/expense/components/expense/expense.component.html
// module id = 1129
// module chunks = 1